import React, { Fragment, useState, useCallback, useRef, useEffect } from "react";
import { useInput, FileField, useFormContext, useDataProvider, useTranslate } from 'react-admin';
import { Card, Typography, CardContent, TextField as MUITextField, Button, Box, Dialog, DialogActions, DialogContent, DialogContentText,DialogTitle } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useFormState } from 'react-final-form';
import FilesInputItem from './FilesInputItem.component';
import { useStyles } from "./FileManager.styles";
import {
	arrayMove,
	SortableContext,
	sortableKeyboardCoordinates,
	rectSwappingStrategy,
} from '@dnd-kit/sortable';
import {useDroppable} from '@dnd-kit/core';

const DragIcon = ({ className }) => <svg className={className} fill='#0000008a' width='50px' viewBox='0 0 512 512'>
	<path d='M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z' />
</svg>;
const DragOverIcon = () => <svg width="40px" viewBox="0 0 384 512">
	<path d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"/>
</svg>;

const FilesInput = ({ groupId = 1, title, items, openFileSelector, handleFileDrop, transformFiles = (f) => ({file: f}), ...rest}) => {
	const classes = useStyles();
	const translate = useTranslate();
	const {setNodeRef} = useDroppable({
		id: groupId,
		data: {}
	});
	const dragEnterTargetRef = useRef(null);
	const [isDragOver, setDragOver] = useState(false);

	const handleDragEnter = useCallback((e) => {
		dragEnterTargetRef.current = e.target;
		setDragOver(true);
	}, []);
	const handleDragLeave = useCallback((e) => {
		if(dragEnterTargetRef.current == e.target) {
			setDragOver(false);
		}
	}, []);
	const handleDragOver = useCallback((e) => {
		e.preventDefault();
	}, []);
	const handleDragDrop = useCallback((e) => {
		e.preventDefault();
		setDragOver(false);
		handleFileDrop(e, transformFiles);
	}, [handleFileDrop, transformFiles]);

	return <SortableContext id={groupId} items={items.map(item => item.uid)}>
		<Card variant="outlined" className={classes.filesCard}>
			<CardContent>
				<Box display="flex" alignItems="center" justifyContent="space-between">
					<div>
						<Typography variant="h5" component="h2" align="left">{title}</Typography>
						<Typography color="textSecondary">{translate('ra.fileManager.info')}</Typography>
					</div>
					<Button variant="contained" color="primary" onClick={() => openFileSelector(transformFiles)} startIcon={<AddIcon />}>
						{translate('ra.fileManager.selectFiles')}
					</Button>
				</Box>
				<div className={classes.filesContainer} ref={setNodeRef} onDrop={handleDragDrop} onDragOver={handleDragOver} onDragEnter={handleDragEnter} onDragLeave={handleDragLeave}>
					{items.map(item => <FilesInputItem key={item.uid} data={item} {...rest} />)}

					{items.length === 0 && <DragIcon className={classes.filesEmptyIcon} />}

					<div className={classes.filesContainerDragOver} style={{ opacity: isDragOver ? 1 : 0, zIndex: isDragOver ? 99 : -1, paddingTop: items.length === 0 ? 44 : 0 }}>
						<DragIcon className={classes.dragOverIcon} />
						<Typography variant="subtitle1" >{translate('ra.fileManager.dragOverText')}</Typography>
					</div>
				</div>
			</CardContent>
		</Card>
	</SortableContext>
};

export default FilesInput;